import React, { FC } from 'react';
import AgentLeadTable from '~/pages/agent/components/agent/AgentLeadTable';

const Agent: FC = () => {
  return <AgentLeadTable />;
};

export default Agent;
